module.exports = __webpack_public_path__ + "static/media/OlderWoman.94622b64.jpg";